
import { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  Button,
  Popover,
  Box,
  Typography,
  TextField,
  Checkbox,
  Autocomplete,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Collapse,
  Divider,
  Menu,
  MenuItem,
} from "@mui/material";

import {
  Edit,
  Delete as DeleteIcon,
  Print,
  ExpandMore,
  ExpandLess,
  Visibility,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  SalesOrderListApi,
  ApproveSo,
  DivisionList,
} from "../../../Services/Services";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast, ToastContainer } from "react-toastify";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import config from "../../../config";
import { generatePdf } from "../Sale/SalesOrderPrint";
import { Chip } from "@mui/material";

pdfMake.vfs = pdfFonts.vfs;

export default function SalesOrderTable() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [salesOrders, setSalesOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const baseURL = config.staticBaseURL;
  const [soToApprove, setSoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForOrderId, setShowRemarkForOrderId] = useState(null);
  const [searchStatus, setSearchStatus] = useState("Pending");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedSO, setExpandedSO] = useState(null);

  const [division, setDivision] = useState([]);

  const userRole = localStorage.getItem("role");

  // ✅ NEW: Date Range States
  const dateInputRef = useRef(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  // --- NEW custom date-range states
const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
const [tempCustomDateRange, setTempCustomDateRange] = useState({
  from: "",
  to: "",
});
// Apply Custom Range
const handleApplyCustomDateRange = () => {
  if (tempCustomDateRange.from && tempCustomDateRange.to) {
    setCustomDateRange({ ...tempCustomDateRange });
    setFilters((prev) => ({ ...prev, date_range: "custom" }));
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
  } else {
    toast.warning("Please select both From and To dates");
  }
};

// Cancel Custom Range
const handleCancelCustomDateRange = () => {
  setTempCustomDateRange({ from: "", to: "" });
  setShowCustomDateInputs(false);
};
const handleReset = () => {
  setFilters({
    party: "",
    division: "",
    project_name: "",
    status: "Pending",
    date_range: "today",
  });
  setCustomDateRange({ from: "", to: "" });
  setTempCustomDateRange({ from: "", to: "" });  // add
  setShowCustomDateInputs(false);                // add
};

  // ✅ UPDATED: Added date_range to filters
  const [filters, setFilters] = useState({
    party: "",
    division: "",
    project_name: "",
    status: "Pending",
    date_range: "today", // ✅ NEW
  });

  // ✅ NEW: Get Date Range Display Function
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  // ✅ NEW: Format Date Display Function
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ✅ NEW: Handle Reset Function
  // const handleReset = () => {
  //   setFilters({
  //     party: "",
  //     division: "",
  //     project_name: "",
  //     status: "Pending",
  //     date_range: "today",
  //   });
  //   setCustomDateRange({ from: "", to: "" });
  // };

  // ✅ UPDATED: useEffect with customDateRange dependency
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      const updatedFilters = {
        ...filters,
        from_date: customDateRange.from || "",
        to_date: customDateRange.to || "",
      };
      fetchOrders(1, true, updatedFilters);
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters, customDateRange]);

  useEffect(() => {
    const fetchData = async () => {
      const divisions = await DivisionList();
      setDivision(divisions || []);
    };
    fetchData();
  }, []);

  const fetchOrders = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    const data = await SalesOrderListApi(pageNum, filterValues);

    if (reset || pageNum === 1) {
      setSalesOrders(data.results);
    } else {
      setSalesOrders((prev) => [...prev, ...data.results]);
    }

    setHasMore(data.next !== null);
    setPage(pageNum);
  };

  // ✅ UPDATED: fetchMoreData with filters
  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    const updatedFilters = {
      ...filters,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };
    fetchOrders(nextPage, false, updatedFilters);
  };

  const handleApprove = async (order, status, remarks = "") => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveSo(
        order.id,
        approvedById,
        order.status,
        remarkInput
      );

      setSalesOrders((prev) =>
        prev.map((item) => (item.id === order.id ? updated : item))
      );

      toast.success(
        updated.status === "Approved"
          ? "SO approved successfully!"
          : "SO unapproved successfully!"
      );
    } catch (error) {
      toast.error("Failed to toggle SO approval.");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  function formatOnlyDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  // Take only the date part (before T)
  const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

  const [year, month, day] = datePart.split("-");

  return `${day}-${month}-${year}`;
}

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  return (
    <>
      {/* Filters + Button */}
      <Box sx={{ mt: -3, pt: 0, mb: 1, width: "100%" }}>
        {/* ✅ DESKTOP VIEW */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexWrap: "nowrap",
            gap: 1,
            alignItems: "center",
          }}
        >


          {/* Radio Buttons */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
              whiteSpace: "nowrap",
            }}
          >
            <input
              type="radio"
              id="pending"
              name="status"
              value="Pending"
              checked={filters.status === "Pending"}
              onChange={handleFilterChange}
              style={{
                marginLeft: "10px",
                width: "10px",
                height: "10px",
                verticalAlign: "middle",
                transform: "scale(0.9)",
              }}
            />
            <label htmlFor="pending" style={{ fontSize: "12px" }}>
              Pending
            </label>

            <input
              type="radio"
              id="approved"
              name="status"
              value="Approved"
              checked={filters.status === "Approved"}
              onChange={handleFilterChange}
              style={{
                marginLeft: "10px",
                width: "10px",
                height: "10px",
                verticalAlign: "middle",
                transform: "scale(0.9)",
              }}
            />
            <label htmlFor="approved" style={{ fontSize: "12px" }}>
              Approved
            </label>

            <input
              type="radio"
              id="rejected"
              name="status"
              value="Rejected"
              checked={filters.status === "Rejected"}
              onChange={handleFilterChange}
              style={{
                marginLeft: "10px",
                width: "10px",
                height: "10px",
                verticalAlign: "middle",
                transform: "scale(0.9)",
              }}
            />
            <label htmlFor="rejected" style={{ fontSize: "12px" }}>
              Rejected
            </label>
          </Box>

          {/* ✅ NEW: Date Range Dropdown */}
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"

                      : filters.date_range === "this_month"
                        ? "This Month"

                        : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              minWidth: 160,
              "& .MuiInputBase-input": {
                fontSize: "0.75rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />

          {/* Search Boxes */}
          <TextField
            label="Search By Debtor."
            name="party"
            value={filters.party}
            onChange={handleFilterChange}
            size="small"
            sx={{
              flex: 1,
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />

          <Autocomplete
            sx={{ width: "180px" }}
            options={division || []}
            getOptionLabel={(opt) => opt?.division || ""}
            isOptionEqualToValue={(opt, val) =>
              opt.division_id === val?.division_id || opt.division_id === val
            }
            value={
              division.find((opt) => opt.division_id === filters.division) ||
              null
            }
            onChange={(e, newValue) =>
              setFilters((prev) => ({
                ...prev,
                division: newValue ? newValue.division_id : "",
              }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Filter by Division"
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
                  "& .MuiInputLabel-root": { fontSize: "0.7rem" },
                }}
              />
            )}
          />

          <TextField
            label="Search by Project Name"
            name="project_name"
            value={filters.project_name}
            onChange={handleFilterChange}
            sx={{
              flex: 1,
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem", top: "-5px" },
            }}
          />

          {/* ✅ NEW: Reset Button */}

        </Box>

        {/* ✅ MOBILE VIEW */}
        <Box
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >

          {/* Radio Buttons - Mobile */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5,
              mb: 1.5,
              p: 1,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <input
                  type="radio"
                  name="status"
                  value="Pending"
                  checked={filters.status === "Pending"}
                  onChange={handleFilterChange}
                />
                Pending
              </label>

              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <input
                  type="radio"
                  name="status"
                  value="Approved"
                  checked={filters.status === "Approved"}
                  onChange={handleFilterChange}
                />
                Approved
              </label>

              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <input
                  type="radio"
                  name="status"
                  value="Rejected"
                  checked={filters.status === "Rejected"}
                  onChange={handleFilterChange}
                />
                Rejected
              </label>
            </Box>


          </Box>

          {/* ✅ NEW: Date Range Dropdown - Mobile */}
          <Box sx={{ px: 1, mb: 1.5 }}>
            <TextField
              fullWidth
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                  customDateRange.from &&
                  customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"

                        : filters.date_range === "this_month"
                          ? "This Month"

                          : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />
          </Box>

          {/* Search Fields Grid - Mobile */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
              },
              gap: 1.5,
              px: 1,
            }}
          >
            <TextField
              label="Search By Debtor"
              name="party"
              value={filters.party}
              onChange={handleFilterChange}
              size="small"
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />

            <Autocomplete
              fullWidth
              options={division || []}
              getOptionLabel={(opt) => opt?.division || ""}
              isOptionEqualToValue={(opt, val) =>
                opt.division_id === val?.division_id || opt.division_id === val
              }
              value={
                division.find((opt) => opt.division_id === filters.division) ||
                null
              }
              onChange={(e, newValue) =>
                setFilters((prev) => ({
                  ...prev,
                  division: newValue ? newValue.division_id : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Filter by Division"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 40,
                    },
                  }}
                />
              )}
            />

            <TextField
              label="Search by Project Name"
              name="project_name"
              value={filters.project_name}
              onChange={handleFilterChange}
              size="small"
              fullWidth
              sx={{
                gridColumn: { xs: "1", sm: "1 / -1" },
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* ✅ NEW: Hidden Date Input for Custom Range */}
      <input
        ref={dateInputRef}
        type="date"
        style={{
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: "1px",
          height: "1px",
        }}
        value={
          selectingDate === "from" ? customDateRange.from : customDateRange.to
        }
        min={selectingDate === "to" ? customDateRange.from : undefined}
        onChange={(e) => {
          const selectedDate = e.target.value;

          if (selectingDate === "from") {
            setCustomDateRange((prev) => ({ ...prev, from: selectedDate }));
            setSelectingDate("to");
            setTimeout(() => {
              dateInputRef.current?.showPicker();
            }, 100);
          } else if (selectingDate === "to") {
            setCustomDateRange((prev) => ({ ...prev, to: selectedDate }));
            setFilters((prev) => ({ ...prev, date_range: "custom" }));
            setSelectingDate(null);
            setDateMenuAnchor(null);
          }
        }}
      />

      {/* ✅ NEW: Date Range Menu */}
     {/* Date Range Menu - Simplified with Custom Dual Picker */}
<Menu
  anchorEl={dateMenuAnchor}
  open={Boolean(dateMenuAnchor)}
  onClose={() => {
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
    setTempCustomDateRange({ from: "", to: "" });
  }}
  PaperProps={{ sx: { width: 340, maxHeight: 500 } }}
>
  {/* Today */}
  <MenuItem
    onClick={() => {
      setFilters((p) => ({ ...p, date_range: "today" }));
      setCustomDateRange({ from: "", to: "" });
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
      <Typography variant="body2">Today</Typography>
      <Typography variant="caption" color="text.secondary">
        {getDateRangeDisplay("today")}
      </Typography>
    </Box>
  </MenuItem>

  {/* Yesterday */}
  <MenuItem
    onClick={() => {
      setFilters((p) => ({ ...p, date_range: "yesterday" }));
      setCustomDateRange({ from: "", to: "" });
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
      <Typography variant="body2">Yesterday</Typography>
      <Typography variant="caption" color="text.secondary">
        {getDateRangeDisplay("yesterday")}
      </Typography>
    </Box>
  </MenuItem>

  {/* This Week */}
  <MenuItem
    onClick={() => {
      setFilters((p) => ({ ...p, date_range: "this_week" }));
      setCustomDateRange({ from: "", to: "" });
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
      <Typography variant="body2">This Week</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
        {getDateRangeDisplay("this_week")}
      </Typography>
    </Box>
  </MenuItem>

  {/* This Month */}
  <MenuItem
    onClick={() => {
      setFilters((p) => ({ ...p, date_range: "this_month" }));
      setCustomDateRange({ from: "", to: "" });
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
      <Typography variant="body2">This Month</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
        {getDateRangeDisplay("this_month")}
      </Typography>
    </Box>
  </MenuItem>

  <Divider />

  {/* Custom Range Collapsible */}
  <MenuItem
    onClick={() => setShowCustomDateInputs((s) => !s)}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}>
      Custom Date Range
    </Typography>
    {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
  </MenuItem>

  <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
    <Box
      sx={{ px: 2, py: 2, bgcolor: "#f5f5f5", borderTop: "1px solid #e0e0e0" }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, display: "block" }}
      >
        Select Date Range
      </Typography>

      {/* From & To pickers side by side */}
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          label="From Date"
          type="date"
          size="small"
          value={tempCustomDateRange.from}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, from: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: tempCustomDateRange.to || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
        <TextField
          label="To Date"
          type="date"
          size="small"
          value={tempCustomDateRange.to}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, to: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: tempCustomDateRange.from || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
      </Box>

      {tempCustomDateRange.from && tempCustomDateRange.to && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 1.5,
            p: 1,
            bgcolor: "#e8f5e9",
            borderRadius: 1,
            textAlign: "center",
            color: "#2e7d32",
            fontWeight: 500,
          }}
        >
          📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
          {formatDateDisplay(tempCustomDateRange.to)}
        </Typography>
      )}

      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleCancelCustomDateRange}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleApplyCustomDateRange}
          disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  </Collapse>
</Menu>

      <InfiniteScroll
        sx={{ border: "3px solid red" }}
        dataLength={salesOrders.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more records!</p>}
      >
        {/* 🔥 MOBILE VIEW - Expandable List */}
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {salesOrders.map((order, idx) => (
              <Box key={idx}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedSO(expandedSO === order.id ? null : order.id)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${order.status === "Approved"
                        ? "#4caf50"
                        : order.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    {/* SO Number & Status */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{idx + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {order.so_no}
                      </Typography>
                    </Box>

                    {/* Debtor & Date */}
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {order.party_details?.company_name?.substring(0, 25) ||
                          "N/A"}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {new Date(order.order_date + "T00:00:00").toLocaleDateString("en-GB")}
                      </span>
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedSO === order.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedSO === order.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: idx % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${order.status === "Approved"
                          ? "#4caf50"
                          : order.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                        }`,
                    }}
                  >
                    {/* Detailed Info - 2 Column Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Debtor Full */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DEBTOR
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {order.party_details?.company_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* PO Number */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PO NUMBER
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {order.po_number || "N/A"}
                        </Typography>
                      </Box>

                      {/* Division */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {order.division_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Grand Total */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          GRAND TOTAL
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#1976d2",
                          }}
                        >
                          ₹{" "}
                          {order.grand_total
                            ? Number(order.grand_total).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )
                            : "0.0"}
                        </Typography>
                      </Box>

                      {/* Advance Received */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          ADVANCE REC.
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#4caf50",
                          }}
                        >
                          ₹{" "}
                          {order.rec_amount
                            ? Number(order.rec_amount).toLocaleString("en-IN", {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            })
                            : "0.0"}
                        </Typography>
                      </Box>

                      {/* Balance Amount */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BALANCE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#f44336",
                          }}
                        >
                          ₹{" "}
                          {(
                            Number(order.grand_total) - Number(order.rec_amount)
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })}
                        </Typography>
                      </Box>

                      {/* Project Name */}
                      {order.project_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PROJECT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {order.project_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Created By */}
                      {order.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {order.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Approved By */}
                      {order.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {order.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Remarks */}
                    {order.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {order.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Approve - Only Admin */}
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              order.status === "Approved"
                                ? "#e8f5e9"
                                : order.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${order.status === "Approved"
                                ? "#4caf50"
                                : order.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              order.status === "Approved" ||
                              order.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setSoToApprove(order);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                order.status === "Approved"
                                  ? "#4caf50"
                                  : order.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  order.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                order.status === "Approved"
                                  ? "#2e7d32"
                                  : order.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {order.status === "Approved"
                              ? "Approved"
                              : order.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      {/* View, Print Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        {order.project && (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(`${order.project}`, "_blank");
                            }}
                            sx={{
                              bgcolor: "#e1f5fe",
                              borderRadius: "6px",
                              width: 32,
                              height: 32,
                              "&:hover": {
                                bgcolor: "#b3e5fc",
                                transform: "scale(1.05)",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            <Visibility
                              sx={{ fontSize: "1rem", color: "#0288d1" }}
                            />
                          </IconButton>
                        )}
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePdf(order);
                          }}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#1976d2" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              hover
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {userRole != "Staff" && <TableCell>Approve</TableCell>}
                  <TableCell align="center">S.No.</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      minWidth: 100,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    So. No.
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Debtor</TableCell>
                  <TableCell align="center">PO No</TableCell>
                  <TableCell align="center">PO Date</TableCell>
                  <TableCell align="center">Division</TableCell>
                  <TableCell align="center">Grand Total</TableCell>
                  <TableCell align="center">Project</TableCell>
                  <TableCell align="center">Ad Rec</TableCell>
                  <TableCell align="center">Bal Amt</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Remarks</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      minWidth: 140,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {salesOrders.map((order, idx) => {
                  const defaultBg = idx % 2 === 0 ? "#fafafa" : "#ffffff";
                  const hoverBg = "#e3f2fd ";
                  return (
                    <TableRow
                      hover
                      key={idx}
                      sx={{
                        backgroundColor: defaultBg,
                        "&:hover": {
                          backgroundColor: hoverBg,
                          "& td": {
                            backgroundColor: hoverBg,
                          },
                        },
                        "& td": {
                          padding: "0px",
                          paddingLeft: 1,
                          paddingRight: 1,
                          fontSize: "0.7rem",
                          fontSize: { xs: "0.7rem", sm: "0.8rem" },
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell align="center">
                          <Checkbox
                            checked={
                              order.status === "Approved" ||
                              order.status === "Rejected"
                            }
                            onChange={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setSoToApprove(order);
                            }}
                            sx={{
                              padding: 0,
                              paddingLeft: 1,
                              paddingRight: 1,
                              transform: "scale(0.7)",
                              color:
                                order.status === "Approved"
                                  ? "green"
                                  : order.status === "Rejected"
                                    ? "red"
                                    : "grey",
                              "&.Mui-checked": {
                                color:
                                  order.status === "Approved" ? "green" : "red",
                              },
                            }}
                          />
                        </TableCell>
                      )}

                      <TableCell align="center">{idx + 1}</TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          minWidth: 100,
                          backgroundColor: defaultBg,
                          zIndex: 2,
                        }}
                        align="center"
                      >
                        {order.so_no}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            order.status === "Approved"
                              ? "Approved"
                              : order.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            order.status === "Approved"
                              ? "success"
                              : order.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            height: "10px",
                            transform: "scale(0.9)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={order.party_details?.company_name}
                          arrow
                        >
                          <span>
                            {truncateText(
                              order.party_details?.company_name,
                              20
                            )}
                          </span>
                        </Tooltip>
                      </TableCell>

                      <TableCell align="center">{order.po_number}</TableCell>

                      <TableCell align="center">
                        {new Date(order.order_date + "T00:00:00").toLocaleDateString("en-GB")}
                      </TableCell>
                      <TableCell align="center">
                        {order.division_name}
                      </TableCell>
                      <TableCell align="center">
                        {order.grand_total
                          ? Number(order.grand_total).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                          : "0.00"}
                      </TableCell>
                      <TableCell align="center">
                        {order.project_name || "-"}
                      </TableCell>

                      <TableCell align="center">
                        {order.rec_amount
                          ? Number(order.rec_amount).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                          : "0.00"}
                      </TableCell>
                      <TableCell align="center">
                        {(
                          Number(order.grand_total) - Number(order.rec_amount)
                        ).toFixed(1)}
                      </TableCell>

                      <TableCell align="center">
                        {order.approved_name}
                      </TableCell>
                      <TableCell align="center">
                        {order.created_by_name}
                      </TableCell>
                      <TableCell align="center">
                        {formatOnlyDate(order.created_at)}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={order.remarks} arrow>
                          <span>{truncateText(order.remarks, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          minWidth: 140,
                          backgroundColor: defaultBg,
                          zIndex: 2,
                        }}
                        align="center"
                      >
                        <span style={{ display: "inline-block", width: 40 }}>
                          {order.project ? (
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              size="small"
                              color="info"
                              onClick={() =>
                                window.open(`${order.project}`, "_blank")
                              }
                            >
                              <Visibility transform="scale(0.6)" />
                            </IconButton>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 40 }}
                            />
                          )}
                        </span>

                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="default"
                          onClick={() => generatePdf(order)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      <ToastContainer />

      {/* Approve/Reject Popover */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setSoToApprove(null);
          setRemarkInput("");
          setShowRemarkForOrderId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForOrderId === soToApprove?.id ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...soToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setSoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setSoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this Sales order?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(soToApprove?.id);
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(soToApprove?.id);
                    setActionType("Rejected");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}